import { render } from "./UpgradeAccount.vue?vue&type=template&id=22639093"
import script from "./UpgradeAccount.vue?vue&type=script&lang=js"
export * from "./UpgradeAccount.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__